import type { ReactNode } from "react";

export function BulkActionBar({
  count,
  onDeselectAll,
  children,
  itemLabel = "selected",
}: {
  count: number;
  onDeselectAll: () => void;
  children: ReactNode;
  itemLabel?: string;
}) {
  return (
    <div className="flex items-center gap-2 rounded-lg border bg-muted/50 px-4 py-2">
      <span className="text-sm font-medium">
        {count} {itemLabel}
      </span>
      {children}
      <button
        type="button"
        onClick={onDeselectAll}
        className="ml-auto text-xs text-muted-foreground hover:text-foreground cursor-pointer rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/40"
      >
        Deselect all
      </button>
    </div>
  );
}
